<template>
  <fieldset
    role="radiogroup"
    :aria-labelledby="fieldContext?.inputId"
    :aria-describedby="ariaDescribedBy"
    :aria-invalid="fieldContext?.validationStatus.value === 'error'"
    :aria-required="fieldContext?.required.value"
    class="flex w-full flex-col"
    @focus="onFocus"
    @blur="onBlur"
    @change="onChange"
  >
    <slot />
  </fieldset>
</template>

<script lang="ts" setup>
import { computed, onMounted, useId } from "vue";

import { injectFieldContext, provideRadioGroupContext } from "./context";

const modelValue = defineModel<any>();

const defaultName = useId();

const props = defineProps<{
  name?: string;
  disabled?: boolean;
  autofocus?: boolean;
  onFocus?: (event: FocusEvent) => void;
  onChange?: (event: Event) => void;
  onBlur?: (event: FocusEvent) => void;
}>();

const fieldContext = injectFieldContext(null);

const ariaDescribedBy = computed(() => {
  if (!fieldContext) {
    return undefined;
  }

  const ids: string[] = [
    fieldContext.descriptionId,
    fieldContext.hintId,
    fieldContext.validationMessageId,
  ];

  return ids.join(" ");
});

const context = provideRadioGroupContext({
  name: computed(() => props.name ?? defaultName),
  modelValue,
  disabled: computed(() => fieldContext?.disabled.value || props.disabled),
  inputElements: new Set(),
});

const focus = () => {
  const array = [...context.inputElements];
  const first = array[0];

  if (first) {
    first.focus();
  }
};

onMounted(() => {
  if (props.autofocus) {
    focus();
  }
});

defineExpose({ input: { focus } });
</script>
